import { createFileRoute } from "@tanstack/react-router"

import { PendingTransferListPage } from "@/screens/Inventory/subfeatures/PendingTransfers/components"

export const Route = createFileRoute("/app/inventory/_layout/pending-transfers")({
  component: () => <PendingTransferListPage />,
})
